import Core, { damp } from 'smooothy'
import gsap from 'gsap'

export default class Slider {
	constructor() {
		this.sliders = []
		document.querySelectorAll('[data-slider]').forEach(wrapper => {
			this.sliders.push(new ServiceSlider(wrapper))
		})
	}

	destroy() {
		this.sliders.forEach(slider => slider.destroy())
		this.sliders = []
	}
}

class ServiceSlider extends Core {
	lspeed = 0
	prevCurrent = 0
	autoplayInterval = null

	constructor(container) {
		const wrapper = container.querySelector('[data-slider-wrapper]')

		super(wrapper, {
			speedDecay: 0.9,
			snap: true,
		})

		this.container = container
		this.parallaxElements = [...wrapper.querySelectorAll('[data-p]')]
		this.abortController = new AbortController()
		this.boundUpdate = this.update.bind(this)
		gsap.ticker.add(this.boundUpdate)

		this.#createControls()
		this.#handleInteractions()
		this.#disableNativeDrag()
		this.#startAutoplay()
	}

	#createControls() {
		const arrows = [...this.container.querySelectorAll('[data-arrows] > *')]
		const { signal } = this.abortController

		arrows.forEach((arrow, index) => {
			arrow.addEventListener(
				'click',
				() => {
					if (index === 0) this.goToPrev()
					else this.goToNext()
					this.#resetAutoplay()
				},
				{ signal }
			)
		})
	}

	#startAutoplay() {
		this.autoplayInterval = setInterval(() => {
			this.goToNext()
		}, 10000)
	}

	#resetAutoplay() {
		clearInterval(this.autoplayInterval)
		this.#startAutoplay()
	}

	#disableNativeDrag() {
		const { signal } = this.abortController

		this.wrapper.querySelectorAll('img').forEach(img => {
			img.setAttribute('draggable', 'false')
		})

		this.wrapper.addEventListener('dragstart', e => e.preventDefault(), { signal })
	}

	onUpdate = ({ parallaxValues, deltaTime }) => {
		const moveSpeed = ((this.current - this.prevCurrent) / Math.max(deltaTime, 0.001)) * 0.25
		this.prevCurrent = this.current

		this.lspeed = damp(this.lspeed, moveSpeed, 5, deltaTime)

		this.parallaxElements.forEach((element, i) => {
			const offset = parallaxValues[i] * Math.abs(this.lspeed) * 30
			const scale = Math.max(1 - Math.min(Math.abs(this.lspeed), 1) * 0.15, 0.9)
			const imgScale = 1 / scale
			element.style.transform = `translateX(${offset}%) scale(${scale})`
			const img = element.querySelector('img')
			if (img) img.style.transform = `scale(${imgScale})`
		})
	}

	#handleInteractions() {
		const { signal } = this.abortController

		;[...this.wrapper.children].forEach(slide => {
			const link = slide.querySelector('a')
			if (link) link.style.pointerEvents = 'none'

			let startX = 0
			let startY = 0
			let startTime = 0
			let isDragging = false

			const handleMouseDown = e => {
				startX = e.clientX
				startY = e.clientY
				startTime = Date.now()
				isDragging = false
				this.#resetAutoplay()
			}

			const handleMouseMove = e => {
				if (!startTime) return

				const deltaX = Math.abs(e.clientX - startX)
				const deltaY = Math.abs(e.clientY - startY)

				if (deltaX > 5 || deltaY > 5) {
					isDragging = true
				}
			}

			const handleMouseUp = () => {
				const deltaTime = Date.now() - startTime

				if (!isDragging && deltaTime < 200 && link) {
					link.click()
				}

				startTime = 0
				isDragging = false
			}

			slide.addEventListener('mousedown', handleMouseDown, { signal })
			slide.addEventListener('mousemove', handleMouseMove, { signal })
			slide.addEventListener('mouseup', handleMouseUp, { signal })
		})
	}

	destroy() {
		this.abortController?.abort()
		clearInterval(this.autoplayInterval)
		gsap.ticker.remove(this.boundUpdate)
		super.destroy?.()
	}
}
